module.exports = __webpack_public_path__ + "static/media/left-arrow-with-lines.8f998817.svg";